export default __webpack_public_path__ + "static/media/c11.4ee20eb7.png";